import * as React from 'react'

import { MapRef } from 'react-map-gl/mapbox'

import { suspendSymbolFade } from '~/client/src/shared/map/mapCaptureFrame'

// Long enough for the source to reload and place, for a map that never reaches idle.
const SETTLE_TIMEOUT_MS = 1000

// On release the item places again on its resting layer — a label's copy was culled under its
// twin, a pin was filtered out of its layer — and a symbol that places fades in: the item blinks
// out and back. Placing it without the fade, until the map has placed the release, shows it at
// once.
export function useReleaseWithoutFade(
  map: MapRef | undefined,
  selectionKey: string,
): void {
  const previousKey = React.useRef(selectionKey)

  React.useEffect(() => {
    const released = previousKey.current
    previousKey.current = selectionKey
    const gl = map?.getMap()
    if (!gl || !released || released === selectionKey) return undefined

    const resume = suspendSymbolFade(gl)
    const timer = window.setTimeout(resume, SETTLE_TIMEOUT_MS)
    gl.once('idle', resume)
    return () => {
      window.clearTimeout(timer)
      gl.off('idle', resume)
      resume()
    }
  }, [map, selectionKey])
}
